import { render, staticRenderFns } from "./OnboardingChooseServiceModal.vue?vue&type=template&id=39afc4b3&scoped=true"
import script from "./OnboardingChooseServiceModal.vue?vue&type=script&lang=js"
export * from "./OnboardingChooseServiceModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingChooseServiceModal.vue?vue&type=style&index=0&id=39afc4b3&prod&lang=scss&scoped=true"
import style1 from "./OnboardingChooseServiceModal.vue?vue&type=style&index=1&id=39afc4b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39afc4b3",
  null
  
)

export default component.exports